<template>
  <b-container>
    <h1 class="mt-2 mb-4 text-left">Forrástérkép</h1>
    <FundMapStepper :currentStep="this.currentStep" />

    <FundMapCompanyInfo />

    <b-row class="d-flex flex-column flex-sm-row align-items-center px-2 px-sm-0 my-3">
      <b-col cols="12" sm="8" lg="9" xl="10">
        <div class="col-12 d-lg-flex d-md-flex flex-nowrap my-4 ">
          <p class="current-step-icon">{{ currentStep }}</p>
          <p class="description">
            {{ descriptionLookup[this.currentStep] }}
          </p>
        </div>
      </b-col>

      <b-col cols="12" sm="4" lg="3" xl="2">
        <b-button class="save-list-btn" v-if="this.currentStep === 3" @click="openSaveSearchObjectModal"
          >Forráslista mentése</b-button
        >
      </b-col>
    </b-row>

    <b-modal id="save-search-object-modal" hide-header hide-footer centered title="" size="xl">
      <div class="d-block mb-5 p-2 pt-0 ">
        <h1 class="d-flex justify-content-center title"><strong> Forráslista mentése</strong></h1>
        <div class="my-5" style="margin: 0 auto;">
          <h5 class="text-center">Forráslista neve</h5>
          <b-form-input
            id="title"
            v-model="title"
            class="col-12 col-sm-9 col-md-6 col-lg-6"
            placeholder="Adja meg a forráslista nevét."
            trim
          ></b-form-input>
        </div>
        <div class="d-flex justify-content-center">
          <b-button class="mr-2" @click="closeSaveSearchObjectModal">Mégsem</b-button>
          <b-button class="ml-2" @click="saveListOfFunds" variant="primary">Mentés</b-button>
        </div>
      </div>
    </b-modal>

    <CompanyAttributes v-if="this.currentStep === 1" />
    <CategorySelection v-if="this.currentStep === 2" />
    <FundResults v-if="this.currentStep === 3" />
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import FundMapStepper from '../../components/FundMapStepper.vue'
import CategorySelection from './steps/CategorySelection.vue'
import CompanyAttributes from './steps/CompanyAttributes.vue'
import FundResults from './steps/FundResults.vue'
import FundMapCompanyInfo from '../../components/FundMapCompanyInfo.vue'
import * as SearchObjectApi from '../../api/searchObject'
import successToast from '../../mixins/toastSuccess'
import errorToast from '../../mixins/toastError'
import { regex } from '../../regex/regex'
export default {
  mixins: [successToast, errorToast],
  data: function() {
    return {
      descriptionLookup: {
        1: 'Adjon meg néhány adatot a vállalkozásával és a forrás felhasználásával kapcsolatban',
        2: 'Adja meg, hogy milyen célra keres finanszírozási forrást',
        3: 'Ajánlott források listája:'
      },
      title: ''
    }
  },
  components: {
    FundMapStepper,
    CategorySelection,
    CompanyAttributes,
    FundResults,
    FundMapCompanyInfo
  },
  computed: {
    ...mapGetters([
      'currentStep',
      'fundMapCompany',
      'fundMapCompanyAttributes',
      'getUser',
      'searchObjectId',
      'selectedFundMapCategory'
    ])
  },
  methods: {
    validateField(value) {
      return regex.test(value)
    },
    addSearchObjectId(key, value) {
      this.$store.dispatch('setSearchObjectAction', { [key]: value })
    },
    async saveListOfFunds() {
      const isValid = this.validateField(this.title)

      if (!isValid) {
        return this.errorToast(`A következő karakterek használata nem engedélyezett. (< > ; ' ")`)
      }

      const categoryObj = {
        mainCategory: this.selectedFundMapCategory.mainCategory,
        subCategory: this.selectedFundMapCategory.subCategory
      }

      let companyId = ''
      if (this.fundMapCompany.flaggerId) {
        companyId = this.fundMapCompany.flaggerId
      } else if (this.fundMapCompany.imaginaryCompany.companyId) {
        companyId = this.fundMapCompany.imaginaryCompany.companyId
      }

      await SearchObjectApi.patchSearchObjectsById(this.searchObjectId.searchObjectId, {
        userId: this.getUser._id,
        companyId: companyId,
        title: this.title,
        categoryObj: categoryObj
      })

      this.successToast('A mentés sikeres volt! A mentett listát, a kedvencek menüpontból érheti el.')
      this.closeSaveSearchObjectModal()
    },
    openSaveSearchObjectModal() {
      this.$root.$emit('bv::show::modal', 'save-search-object-modal')
    },
    closeSaveSearchObjectModal() {
      this.$root.$emit('bv::hide::modal', 'save-search-object-modal')
    }
  },
  created() {
    if (!this.fundMapCompany) {
      this.$router.push('/fund-map')
    }
  },
  mounted() {
    window.onbeforeunload = function(e) {
      e.returnValue = ''
      return ''
    }
  },
  beforeDestroy() {
    window.onbeforeunload = null
  }
}
</script>

<style lang="scss" scoped>
.current-step-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 56px;
  height: 56px;
  background-color: #00903c;
  color: #fff;
  border-radius: 50%;
  margin-right: 25px;
  margin-left: 10px;
  margin-bottom: 0;
  font-weight: 700;
  font-size: 32px;
}

.description {
  text-align: initial;
  font-weight: 700;
  font-size: 32px;
  margin-bottom: 0;
  margin-left: 10px;
  margin-top: 5px;
}

.save-list-btn {
  width: 100%;
}

@media screen and (min-width: 576px) {
  .save-list-btn {
    width: max-content;
    margin-bottom: 0;
  }
}

@media screen and (max-width: 768px) {
  .title {
    font-size: 28px;
  }
  .current-step-icon {
    width: 56px;
  }
}

@media screen and (max-width: 992px) {
  .description {
    font-size: 24px;
  }
}
</style>
